/**
 * AI Settings Service - Servicio de configuración de IA
 */

import { ApiServiceBase } from '../core/ApiService';

export class AISettingsService extends ApiServiceBase {
  /**
   * Obtiene configuración de IA
   */
  async getAIConfig(): Promise<{
    success: boolean;
    parameter_config: Record<string, any>;
    presets: Record<string, any>;
    available_models: Array<{ id: string; name: string; description: string; max_tokens: number }>;
    default_settings: Record<string, any>;
  }> {
    return this.request('/ai/config');
  }

  /**
   * Obtiene settings de IA del usuario
   */
  async getAISettings(): Promise<{
    success: boolean;
    settings: {
      id?: string;
      user_id?: string;
      settings: Record<string, any>;
    };
    scope: 'default' | 'user';
  }> {
    return this.request('/ai/settings');
  }

  /**
   * Actualiza settings de IA
   */
  async updateAISettings(settings: Record<string, any>): Promise<{
    success: boolean;
    settings: any;
    message: string;
  }> {
    return this.request('/ai/settings', {
      method: 'POST',
      body: JSON.stringify({ settings }),
    });
  }

  /**
   * Aplica un preset de IA
   */
  async applyAIPreset(presetName: string): Promise<{
    success: boolean;
    settings: any;
    preset_applied: {
      name: string;
      description: string;
    };
    message: string;
  }> {
    return this.request('/ai/settings/preset', {
      method: 'POST',
      body: JSON.stringify({ preset_name: presetName }),
    });
  }

  /**
   * Resetea settings de IA
   */
  async resetAISettings(): Promise<{
    success: boolean;
    settings?: any;
    message: string;
  }> {
    return this.request('/ai/settings/reset', {
      method: 'POST',
    });
  }
}
